import { render, staticRenderFns } from "./NutritionFactTable.vue?vue&type=template&id=3bb286ac&scoped=true&"
import script from "./NutritionFactTable.vue?vue&type=script&lang=js&"
export * from "./NutritionFactTable.vue?vue&type=script&lang=js&"
import style0 from "./NutritionFactTable.vue?vue&type=style&index=0&id=3bb286ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb286ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
